import _Object$keys from "@babel/runtime-corejs3/core-js-stable/object/keys";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-symbols";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/filter";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor";
import _forEachInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/for-each";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptors";
import _Object$defineProperties from "@babel/runtime-corejs3/core-js-stable/object/define-properties";
import _Object$defineProperty from "@babel/runtime-corejs3/core-js-stable/object/define-property";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
import _startsWithInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/starts-with";

function ownKeys(object, enumerableOnly) { var keys = _Object$keys(object); if (_Object$getOwnPropertySymbols) { var symbols = _Object$getOwnPropertySymbols(object); if (enumerableOnly) { symbols = _filterInstanceProperty(symbols).call(symbols, function (sym) { return _Object$getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { var _context2; _forEachInstanceProperty(_context2 = ownKeys(Object(source), true)).call(_context2, function (key) { _defineProperty(target, key, source[key]); }); } else if (_Object$getOwnPropertyDescriptors) { _Object$defineProperties(target, _Object$getOwnPropertyDescriptors(source)); } else { var _context3; _forEachInstanceProperty(_context3 = ownKeys(Object(source))).call(_context3, function (key) { _Object$defineProperty(target, key, _Object$getOwnPropertyDescriptor(source, key)); }); } } return target; }

import { useMemo } from 'react';
import bugsnag from '@bugsnag/js';
import useDialog from './use-dialog';
import { ErrorDialog } from '../dialogs/error';

function useErrorDialog(props) {
  var errorDialog = useDialog(ErrorDialog, props);
  var value = useMemo(function () {
    return _objectSpread(_objectSpread({}, errorDialog), {}, {
      open: function open(e) {
        var _context;

        var errorCode = e.serverCode || e.code;

        if (!errorCode || _startsWithInstanceProperty(_context = errorCode.toString()).call(_context, '5')) {
          // Only report if it's not a server error or if it's a 5xx server error
          // to avoid reporting expected 4xx errors
          bugsnag.notify(e, function (error) {
            error.unhandled = false;
          });
        } // NOTE: for whatever reason JS behaves weird when spreading error objects which
        // gets rid of the message, so we pass the message in manually to ensure it gets
        // preserved :/


        errorDialog.open(_objectSpread({
          message: e.message
        }, e));
      }
    });
  }, [errorDialog]);
  return value;
}

export default useErrorDialog;